import type { ProjectTask } from '../types';

/**
 * Normalize `assignedTo` from Firestore (array, legacy single string, or missing).
 */
export function normalizeTaskAssignedTo(task: Pick<ProjectTask, 'assignedTo'>): string[] {
  const raw = task.assignedTo as unknown;
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((x) => String(x)).filter((id) => id.length > 0);
  }
  if (typeof raw === 'string' && raw.trim()) return [raw.trim()];
  return [];
}

/** True if this user is an assignee or has internal action required on the task. */
export function taskInvolvesUser(task: ProjectTask, userId: string): boolean {
  if (!userId) return false;
  if (normalizeTaskAssignedTo(task).includes(userId)) return true;
  if (task.actionRequired === userId) return true;
  return false;
}
